class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const form = this.querySelector("form");
    form.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const desktopWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (desktopWrapper) {
      desktopWrapper.addEventListener("keyup", onKeyUpEscape);
    }
  }

  static setListeners() {
    const onPopState = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams !== FacetFiltersForm.searchParamsPrev) {
        FacetFiltersForm.renderPage(searchParams, null, false);
      }
    };
    window.addEventListener("popstate", onPopState);
  }

  static toggleActiveFacets(disabled = true) {
    document.querySelectorAll(".js-facet-remove").forEach((el) => {
      el.classList.toggle("disabled", disabled);
    });
  }

  static renderPage(searchParams, event, updateHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();
    const productCountEls = document.querySelectorAll(".product-count");
    const productCountDesktopEls = document.querySelectorAll(
      ".product-count-desktop",
    );

    if (productCountEls.length > 0) {
      productCountEls.forEach((el) => el.classList.add("loading"));
    }
    if (productCountDesktopEls.length > 0) {
      productCountDesktopEls.forEach((el) => el.classList.add("loading"));
    }

    sections.forEach((sectionConfig) => {
      const fetchUrl = `${window.location.pathname}?section_id=${sectionConfig.section}&${searchParams}`;
      const matchesCached = (entry) => entry.url === fetchUrl;

      if (sectionConfig.product_grid) {
        document
          .getElementById("ProductGridContainer")
          .querySelector(".collection")
          .classList.add("loading");
      }

      if (FacetFiltersForm.filterData.some(matchesCached)) {
        FacetFiltersForm.renderSectionFromCache(matchesCached, sectionConfig, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(fetchUrl, sectionConfig, event);
      }
    });

    if (updateHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static scrollToTop() {
    const gridHolder = document.getElementById("product-grid-holder");
    const headerOffset = document.querySelector("sticky-header").clientHeight - 1;
    const targetY =
      gridHolder.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    return new Promise((resolve, reject) => {
      const failTimer = setTimeout(() => {
        reject(new Error("Scrolling to top failed"));
      }, 2000);

      const onScroll = () => {
        if (Math.abs(window.pageYOffset - targetY) < 20) {
          console.log("WE AARE GETTING HERE");
          window.removeEventListener("scroll", onScroll);
          clearTimeout(failTimer);
          resolve();
        }
      };

      if (Math.abs(window.pageYOffset - targetY) < 20) {
        window.removeEventListener("scroll", onScroll);
        resolve();
      }

      window.addEventListener("scroll", onScroll);
      window.scrollTo({ top: targetY, behavior: "smooth" });
    });
  }

  static renderSectionFromFetch(url, sectionConfig, event) {
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        FacetFiltersForm.scrollToTop()
          .then(() => {
            FacetFiltersForm.filterData = [
              ...FacetFiltersForm.filterData,
              { html, url },
            ];
            FacetFiltersForm.renderFilters(html, sectionConfig, event);
            if (sectionConfig.product_grid) {
              FacetFiltersForm.renderProductGridContainer(html);
            }
            FacetFiltersForm.renderProductCount(html);
            if (typeof initializeScrollAnimationTrigger === "function") {
              initializeScrollAnimationTrigger(html);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
  }

  static renderSectionFromCache(matchFn, sectionConfig, event) {
    const cached = FacetFiltersForm.filterData.find(matchFn);
    if (!cached) {
      return;
    }
    const html = cached.html;

    FacetFiltersForm.scrollToTop()
      .then(() => {
        FacetFiltersForm.renderFilters(html, sectionConfig, event);
        if (sectionConfig.product_grid) {
          FacetFiltersForm.renderProductGridContainer(html);
        }
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function") {
          initializeScrollAnimationTrigger(html);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  static renderProductGridContainer(htmlString) {
    const parser = new DOMParser().parseFromString(htmlString, "text/html");
    const container = document.getElementById("ProductGridContainer");
    container.innerHTML = parser.getElementById("ProductGridContainer").innerHTML;
    container.querySelectorAll(".scroll-trigger").forEach((el) => {
      el.classList.add("scroll-trigger--cancel");
    });
  }

  static renderProductCount(htmlString) {
    const countHtml = new DOMParser()
      .parseFromString(htmlString, "text/html")
      .getElementById("ProductCount").innerHTML;

    console.log("THIS IS THE COUNT", countHtml);

    document.querySelectorAll(".product-count").forEach((el) => {
      el.innerHTML = countHtml;
      el.classList.remove("loading");
    });
    document.querySelectorAll(".product-count-desktop").forEach((el) => {
      el.innerHTML = countHtml;
      el.classList.remove("loading");
    });
  }

  /**
   * Keeps live facet filter nodes in sync with the section HTML: update innerHTML,
   * insert filters that reappear after being omitted, remove filters no longer present.
   * Removing only orphans left "holes" when filters came back (e.g. Color after clear).
   */
  static syncFacetFilterElements(parsed, sectionRoot, event) {
    const activeContainer = event?.target?.closest?.(".js-filter");

    const shouldSkipInnerUpdate = (newEl) =>
      Boolean(
        activeContainer && newEl.dataset.index === activeContainer.dataset.index,
      );

    const insertMissingFilter = (liveForm, imported, newFilterEls, i) => {
      const prevNew = newFilterEls[i - 1];
      if (prevNew) {
        const prevLive = liveForm.querySelector(
          `.js-filter[data-index="${prevNew.dataset.index}"]`,
        );
        if (prevLive) {
          prevLive.insertAdjacentElement("afterend", imported);
          return;
        }
      }
      const firstLive = liveForm.querySelector(".js-filter");
      if (firstLive) {
        firstLive.parentNode.insertBefore(imported, firstLive);
        return;
      }
      const wrapper =
        liveForm.querySelector("#FacetsWrapperDesktop") ||
        liveForm.querySelector(".mobile-facets__main") ||
        liveForm;
      const script = wrapper.querySelector("script[src*='show-more.js']");
      if (script?.parentNode) {
        script.insertAdjacentElement("afterend", imported);
      } else {
        wrapper.appendChild(imported);
      }
    };

    [
      "#FacetFiltersForm",
      "#FacetFiltersFormMobile",
      "#FacetFiltersPillsForm",
    ].forEach((formSelector) => {
      const newForm = parsed.querySelector(formSelector);
      const liveForm = sectionRoot.querySelector(formSelector);
      if (!newForm || !liveForm) return;

      const newFilterEls = Array.from(newForm.querySelectorAll(".js-filter"));

      newFilterEls.forEach((newEl, i) => {
        const idx = newEl.dataset.index;
        let live = liveForm.querySelector(`.js-filter[data-index="${idx}"]`);

        if (live) {
          if (!shouldSkipInnerUpdate(newEl)) {
            live.innerHTML = newEl.innerHTML;
          }
        } else {
          const imported = document.importNode(newEl, true);
          insertMissingFilter(liveForm, imported, newFilterEls, i);
        }
      });

      const newIndices = new Set(newFilterEls.map((el) => el.dataset.index));
      liveForm.querySelectorAll(".js-filter").forEach((el) => {
        if (!newIndices.has(el.dataset.index)) {
          el.remove();
        }
      });
    });
  }

  static renderFilters(htmlString, sectionConfig, event) {
    const parsed = new DOMParser().parseFromString(htmlString, "text/html");
    const sectionRoot = document.querySelector(
      "#shopify-section-" + sectionConfig.section,
    );

    const newFilters = parsed.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );

    const isActiveFilter = (filterEl) => {
      const activeContainer = event
        ? event.target.closest(".js-filter")
        : undefined;
      return (
        !!activeContainer && filterEl.dataset.index === activeContainer.dataset.index
      );
    };

    const activeFilterFromResponse = Array.from(newFilters).find(isActiveFilter);

    FacetFiltersForm.syncFacetFilterElements(parsed, sectionRoot, event);

    FacetFiltersForm.renderActiveFacets(parsed, sectionRoot);
    FacetFiltersForm.renderAdditionalElements(parsed, sectionRoot);

    if (activeFilterFromResponse && event) {
      FacetFiltersForm.renderCounts(
        activeFilterFromResponse,
        event.target.closest(".js-filter"),
        sectionRoot,
      );
    }
  }

  static renderActiveFacets(parsed, sectionRoot) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((selector) => {
      const next = parsed.querySelector(selector);
      if (next) {
        sectionRoot.querySelector(selector).innerHTML = next.innerHTML;
      }
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(parsed, sectionRoot) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(
      (selector) => {
        if (parsed.querySelector(selector)) {
          sectionRoot.querySelector(selector).innerHTML =
            parsed.querySelector(selector).innerHTML;
        }
      },
    );
    sectionRoot
      .querySelector("#FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(newFilterEl, currentFilterEl, sectionRoot) {
    const isDrawer = Boolean(document.querySelector(".facets-container-drawer"));

    const selectedSelector = isDrawer
      ? ".mobile-facets__list"
      : ".facets__selected";

    const currentSelected = currentFilterEl.querySelector(selectedSelector);
    const newSelected = newFilterEl.querySelector(selectedSelector);

    const currentSummary = isDrawer && currentFilterEl.querySelector(".facets__summary");
    const newSummary = isDrawer && newFilterEl.querySelector(".facets__summary");

    if (newSelected && currentSelected) {
      const activeElementId = document.activeElement.id;
      const showMoreExpanded = Boolean(
        currentFilterEl.querySelector("show-more-button .label-show-more.hidden"),
      );

      currentSelected.outerHTML = newSelected.outerHTML;

      if (!isDrawer) {
        const currentWrap = currentFilterEl.querySelector(".facets-wrap");
        const newWrap = newFilterEl.querySelector(".facets-wrap");
        if (newWrap && currentWrap) {
          if (showMoreExpanded) {
            newWrap.querySelectorAll(".facets__item.hidden").forEach((el) => {
              el.classList.replace("hidden", "show-more-item");
            });
          }
          currentWrap.outerHTML = newWrap.outerHTML;
        }
      }

      const elToFocus = document.getElementById(activeElementId);
      if (elToFocus) {
        elToFocus.focus();
      }
    }

    if (currentSummary && newSummary) {
      currentFilterEl.querySelector(".facets__summary").outerHTML =
        newFilterEl.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
        product_grid: true,
      },
      {
        section: document.getElementById("filter-holder").dataset.id,
        product_grid: false,
      },
    ];
  }

  createSearchParams(formEl) {
    return new URLSearchParams(new FormData(formEl)).toString();
  }

  onSubmitForm(searchParams, event) {
    console.log("SEARCH PARAMS:", searchParams);
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = event.target.closest("form");
    const isAside = form.classList.contains("form-location-aside");
    const isSearchTemplate = window.template.current === "search";
    const searchModalForm = document.querySelector(".search-modal__form form");

    document.querySelectorAll(".no-js-list").forEach((el) => el.remove());

    if (isAside) {
      const paramChunks = [];
      document.querySelectorAll(".form-location-aside").forEach((asideForm) => {
        paramChunks.push(this.createSearchParams(asideForm));
      });
      if (isSearchTemplate && searchModalForm) {
        paramChunks.push(this.createSearchParams(searchModalForm));
      }
      this.onSubmitForm(paramChunks.reverse().join("&"), event);
    } else {
      this.onSubmitForm(this.createSearchParams(form), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();

    const href = event.currentTarget.href;
    const query =
      href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(query);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", this.onRangeChange.bind(this));
    });

    this.rangeSlider = this.querySelector(".price-range-slider");
    this.setMinAndMaxValues(true);
    this.initAutoWidthFields();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.querySelectorAll(".fields__input--auto-width").forEach((input) => {
      this.syncAutoWidthField(input);
    });
  }

  setMinAndMaxValues(runSliderInit) {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute("max", maxInput.value);
    }
    if (minInput.value) {
      maxInput.setAttribute("min", minInput.value);
    }
    if (minInput.value === "") {
      maxInput.setAttribute("min", 0);
    }
    if (maxInput.value === "") {
      minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    const minVal = minInput.value ? parseFloat(minInput.value) : 0;
    const maxVal = maxInput.value
      ? parseFloat(maxInput.value)
      : parseFloat(maxInput.getAttribute("max"));
    const rangeMax = parseFloat(maxInput.getAttribute("max"));

    if (this.rangeSlider && runSliderInit) {
      this.rangeSlider.innerHTML = "";
      this.initRangeSlider(runSliderInit, minVal, maxVal, 0, rangeMax);
    }
  }

  updateInputValues(minVal, maxVal, rangeMin, rangeMax, dispatchInput) {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (minVal === rangeMin) {
      minInput.value = null;
    } else {
      minInput.value = minVal;
    }
    if (maxVal === rangeMax) {
      maxInput.value = null;
    } else {
      maxInput.value = maxVal;
    }

    this.querySelectorAll(".fields__input--auto-width").forEach((input) => {
      this.syncAutoWidthField(input);
    });

    if (dispatchInput) {
      const form = this.closest("form");
      form.dispatchEvent(new Event("input"));
    }
  }

  initRangeSlider(runSliderInit, minVal, maxVal, rangeMin, rangeMax) {
    if (!runSliderInit) return;

    const slider = noUiSlider.create(this.rangeSlider, {
      start: [minVal, maxVal],
      connect: true,
      range: { min: rangeMin, max: rangeMax },
      format: {
        to: (v) => parseFloat(v).toFixed(2),
        from: (v) => parseFloat(v).toFixed(2),
      },
    });

    const snap = (values) => {
      const a = (50 * Math.round(Number(values[0]) / 50)).toFixed(2);
      const b = (50 * Math.round(Number(values[1]) / 50)).toFixed(2);
      return [a, b];
    };

    slider.on("slide", (values) => {
      const [a, b] = snap(values);
      this.updateInputValues(a, b, rangeMin, rangeMax, false);
    });

    slider.on("end", (values) => {
      const [a, b] = snap(values);
      this.updateInputValues(a, b, rangeMin, rangeMax, true);
    });
  }

  adjustToValidValues(input) {
    const num = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));
    if (num < min) input.value = min;
    if (num > max) input.value = max;
  }

  syncAutoWidthField(input) {
    if (!input || !input.classList.contains("fields__input--auto-width")) {
      return;
    }

    const style = window.getComputedStyle(input);
    const measure = document.createElement("span");
    measure.style.cssText = [
      "position:fixed",
      "visibility:hidden",
      "white-space:pre",
      "top:0",
      "left:0",
      `font:${style.font}`,
      `letter-spacing:${style.letterSpacing}`,
      `padding:${style.padding}`,
      `border:${style.border}`,
    ].join(";");
    measure.textContent = String(input.value || input.placeholder || "0");
    document.body.appendChild(measure);

    const width = Math.ceil(measure.getBoundingClientRect().width) + 4;
    input.style.width = `${width}px`;
    document.body.removeChild(measure);
  }

  initAutoWidthFields() {
    this.querySelectorAll(".fields__input--auto-width").forEach((input) => {
      this.syncAutoWidthField(input);
      ["input", "change"].forEach((type) => {
        input.addEventListener(type, () => this.syncAutoWidthField(input));
      });
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector("a");
    link.setAttribute("role", "button");
    link.addEventListener("click", this.closeFilter.bind(this));
    link.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") {
        this.closeFilter(event);
      }
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
